<template lang="pug">
v-app.client-page
  xo-toolbar
  .client-section.mx-auto(style="max-width: 1600px; width: 100%; color: black")
    .client-banner
      .vertical-border-blue
      .clients-text-container
        p.clients-title.font-weight-light Who We
        p.clients-title.font-weight-light Work With
        p.clients-subtitle.font-weight-light THIS TIME, NO NEED TO ASK US, ASK THEM!
      v-spacer
      .d-flex.clients-avatar-container
        img.mr-1.center(src="/images/new/client/Clients1.png")
        img.mr-1.left(src="/images/new/client/Clients2.jpg")
        img.mr-1.left(src="/images/new/client/Clients3.png")
        img.center(src="/images/new/client/Clients4.jpg")

    v-row.client-logo-container
      v-col.col-flex(cols="12") 
        img(
          v-for="(slide, i) in avatar",
          :data-index="i",
          :src="`/images/new/client/${slide}.png`"
        )
      v-col.col-flex(cols="12") 
        img(
          v-for="(slide, i) in avatar2",
          :data-index="i",
          :src="`/images/new/client/${slide}.png`"
        )

    v-row.clients-testimonial-container
      v-col.testimonial-card-1(cols="12", md="6", sm="6")
        v-card.testimonial-card(style="margin-left: auto")
          v-icon.quote(color="#F5951C") mdi-format-quote-open
          v-card-text.testimonial-card-text
            label.testimonial-text.text-black Having <b>JustAsk!</b> reliably take care of the little details of my life has helped me free up my headspace to focus on the things that matter. It allows me to concentrate my energy on what I am good at instead of spreading myself too thinly. Having <b>JustAsk!</b> in my life has greatly helped increase my productivity and overall well-being.
            .d-flex.testimonial-details
              img(src="/images/new/client/Testimonials Mench.png")
              .details
                v-rating(
                  length="5",
                  value="5",
                  readonly,
                  color="#0E97A9",
                  :size="$vuetify.breakpoint.smAndDown ? 17 : 25"
                )
                div(style="padding-left: 10px"): span.text-black MENCH DIZON, CONSULTANT & ENTREPRENEUR
      v-col.testimonial-card-2.denise-card(cols="12", md="6", sm="6")
        v-card.testimonial-card
          v-icon.quote(color="#F5951C") mdi-format-quote-open
          v-card-text.testimonial-card-text
            label.testimonial-text.text-black I'm very happy with the services of <b>JustAsk!</b>. It allowed me more time to focus on writing, teaching, and doing what's important when all the administrative work and customer service is taken care of. It has streamlined my operations and allowed me to grow my business.
            .d-flex.testimonial-details.denise-detailes
              img.denise(src="/images/new/client/Testimonials Denise.jpg")
              .details
                v-rating(
                  length="5",
                  value="5",
                  readonly,
                  color="#0E97A9",
                  :size="$vuetify.breakpoint.smAndDown ? 16 : 23"
                )
                div(style="padding-left: 10px"): span.text-black DENISE CELDRAN, HOMEOPATHY PHILIPPINES
</template>

<script>
export default {
    data() {
        return {
            avatar: [
                "Logo Area63",
                "Logo Homeopathy PH",
                "LogoTheSecretSauce",
                "Logo BGA",
                "Logo mocean-DkBlue",
                "Logo apperPH",
            ],
            avatar2: [
                "Logo PixOwl",
                "Logo Sprinkle FIC",
                "LogoVIPTraveler",
                "Logo Wivity",
                "Logo YGG Pinas",
                "Logo YGG",
            ],
        };
    },
    created() {
        document.body.classList.add("client-body");
    },
};
</script>

<style lang="scss">
// @media (min-width: 1264px) and (max-width: 1441px) {
//   .client-body {
//     zoom: 0.8 !important;
//     height: 100vh !important;
//   }
// }

.client-page {
    .clients-title {
        font-family: "GothamRounded" !important;
        font-weight: light !important;
    }

    .col-flex {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
    }

    @media (max-width: 599px) {
        .col-flex {
            flex-wrap: wrap !important;
        }
    }

    //large
    @media (min-width: 1265px) {
        .client-section {
            margin-top: 50px;

            .client-banner {
                display: flex;
                align-items: center;
                background-color: #f2f2f2;
                padding: 0 50px;
                .vertical-border-blue {
                    border-left: 50px solid #009cb5;
                    border-right: 20px solid #7dccad;
                    height: 350px;
                }
                .clients-avatar-container {
                    background-color: #7dccad;

                    img {
                        // height: 100%;
                        width: 210px;
                    }
                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }

                .clients-text-container {
                    max-width: 340px;
                    margin: 0 65px;
                    .clients-title {
                        font-family: "GothamRounded";
                        font-weight: light;
                        padding: 0;
                        font-size: 3rem;
                        line-height: 40px;
                    }
                    .clients-subtitle {
                        font-size: 0.9rem;
                    }
                }
            }
            .client-logo-container {
                max-width: 1345px;
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 210px;
                    padding: 0 24px;
                }
                .img-2 {
                    width: 165px !important;
                    padding: 0 24px;
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .clients-testimonial-container {
                max-width: 1108px;
                margin: auto;
                .testimonial-card-1 {
                    padding: 0 30px;
                }
                .testimonial-card-2 {
                    padding: 0 30px;
                }
                .testimonial-card {
                    border-radius: 10px;
                    margin: 30px 0;
                    height: 239px;
                    position: relative;
                    max-width: 600px;
                    padding: 10px;
                    .quote {
                        position: absolute;
                        top: -37px;
                        left: 2px;
                        font-size: 90px;
                    }
                    .denise {
                        -webkit-transform: scaleX(-1);
                        transform: scaleX(-1);
                    }
                    .testimonial-card-text {
                        margin-top: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 232px;
                        .testimonial-text {
                            padding: 5px 16px;
                            margin-top: 0;
                            font-size: 0.9rem;
                            line-height: 22px;
                        }
                        .testimonial-details {
                            font-size: 1.4rem;
                            margin: 0 14px;
                            display: flex;
                            align-items: center;
                            .details {
                                padding: 0;
                                margin-left: 5px;
                                .v-rating {
                                    margin-bottom: -10px;
                                    font-size: 10px;
                                }
                                span {
                                    margin-top: -10px;
                                    font-size: 0.75rem;
                                }
                            }

                            img {
                                height: 50px;
                                border-radius: 10px;
                            }
                        }
                    }
                }
            }
        }
    }

    //medium
    @media (min-width: 961px) and (max-width: 1264px) {
        .client-section {
            margin-top: 50px;

            .client-banner {
                display: flex;
                align-items: center;
                background-color: #f2f2f2;
                padding: 0 60px;
                .vertical-border-blue {
                    border-left: 40px solid #009cb5;
                    border-right: 15px solid #7dccad;
                    height: 229px;
                }
                .clients-avatar-container {
                    background-color: #7dccad;

                    img {
                        // height: 259px;
                        width: 135px;
                    }
                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }

                .clients-text-container {
                    max-width: 224px;
                    margin: 0 43px;
                    .clients-title {
                        font-family: "GothamRounded";
                        font-weight: light;
                        padding: 0;
                        font-size: 1.7rem;
                        line-height: 20px;
                    }
                    .clients-subtitle {
                        font-size: 0.6rem;
                    }
                }
            }
            .client-logo-container {
                max-width: 915px;
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 147px;
                    padding: 0 17px;
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .clients-testimonial-container {
                max-width: 880px;
                margin: auto;
                .testimonial-card-1 {
                    padding: 0 30px;
                }
                .testimonial-card-2 {
                    padding: 0 30px;
                }
                .testimonial-card {
                    border-radius: 10px;
                    margin: 30px 0;
                    height: 198px;
                    position: relative;
                    max-width: 600px;
                    padding: 10px;
                    .quote {
                        position: absolute;
                        top: -30px;
                        left: 2px;
                        font-size: 75px;
                    }
                    .denise {
                        -webkit-transform: scaleX(-1);
                        transform: scaleX(-1);
                    }
                    .testimonial-card-text {
                        margin-top: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 194px;
                        .testimonial-text {
                            padding: 5px 0;
                            margin-top: 0;
                            font-size: 0.68rem;
                            line-height: 15px;
                        }
                        .testimonial-details {
                            font-size: 1.4rem;
                            margin: 0;
                            display: flex;
                            align-items: center;
                            .details {
                                padding: 0;
                                margin-left: 5px;
                                .v-rating {
                                    margin-bottom: -10px;
                                    font-size: 10px;
                                }
                                span {
                                    margin-top: -10px;
                                    font-size: 0.62rem;
                                }
                            }

                            img {
                                height: 42px;
                                border-radius: 8px;
                            }
                        }
                    }
                }
            }
        }
    }

    //small
    @media (min-width: 599px) and (max-width: 961px) {
        .client-section {
            margin-top: 50px;

            .client-banner {
                display: flex;
                align-items: center;
                background-color: #f2f2f2;
                padding: 0 35px;
                .vertical-border-blue {
                    border-left: 40px solid #009cb5;
                    border-right: 15px solid #7dccad;
                    height: 195px;
                }
                .clients-avatar-container {
                    background-color: #7dccad;

                    img {
                        height: 195px;
                        width: 114px;
                    }
                    .center {
                        object-position: 20% 0;
                    }
                    .left {
                        object-position: 80% 0;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }

                .clients-text-container {
                    max-width: 224px;
                    margin: 0 43px;
                    .clients-title {
                        font-family: "GothamRounded";
                        font-weight: light;
                        padding: 0;
                        font-size: 1rem;
                        line-height: 5px;
                    }
                    .clients-subtitle {
                        font-size: 0.5rem;
                    }
                }
            }
            .client-logo-container {
                max-width: 657px;
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 97px;
                    padding: 0 6px;
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .clients-testimonial-container {
                max-width: 880px;
                margin: auto;
                display: flex;
                flex-direction: inline;
                .testimonial-card-1 {
                    padding: 0 10px;
                }
                .testimonial-card-2 {
                    padding: 0 10px;
                }
                .testimonial-card {
                    border-radius: 10px;
                    margin: 30px 0;
                    height: 215px;
                    position: relative;
                    max-width: 317px;
                    padding: 10px;
                    .quote {
                        position: absolute;
                        top: -26px;
                        left: 2px;
                        font-size: 65px;
                    }
                    .denise {
                        -webkit-transform: scaleX(-1);
                        transform: scaleX(-1);
                    }
                    .testimonial-card-text {
                        margin-top: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 212px;
                        .testimonial-text {
                            padding: 5px 0;
                            margin-top: 0;
                            font-size: 0.68rem;
                            line-height: 15px;
                        }
                        .testimonial-details {
                            font-size: 1.4rem;
                            margin: 0;
                            display: flex;
                            align-items: center;
                            .details {
                                padding: 0;
                                margin-left: 5px;
                                .v-rating {
                                    margin-bottom: -10px;
                                    font-size: 10px;
                                }
                                span {
                                    margin-top: -10px;
                                    font-size: 0.52rem;
                                }
                            }

                            img {
                                height: 35px;
                                border-radius: 8px;
                            }
                        }
                    }
                }
            }
        }
    }

    //xs
    @media (min-width: 320px) and(max-width: 599px) {
        .client-section {
            margin-top: 50px;

            .client-banner {
                display: flex;
                flex-direction: column;
                background-color: #f2f2f2;
                padding: 0;
                .vertical-border-blue {
                    background-color: #009cb5;
                    height: 20px;
                    width: 100%;
                }
                .clients-avatar-container {
                    background-color: #7dccad;
                    display: flex;
                    flex-direction: row;
                    overflow-x: scroll;
                    overflow-y: hidden;
                    img {
                        pointer-events: none;
                        height: 350px;
                        width: 50%;
                        object-fit: cover;
                    }
                    .center {
                        object-position: 60% 32%;
                    }
                    .left {
                        object-position: 10% 22%;
                    }
                    .mr-1 {
                        margin-right: 5px;
                    }
                }

                .clients-text-container {
                    max-width: auto;
                    margin: 40px 43px;

                    .clients-title {
                        font-family: "GothamRounded";
                        font-weight: light;
                        padding: 0;
                        font-size: 2rem;
                        line-height: 20px;
                    }
                    .clients-subtitle {
                        margin: 0;
                        font-size: 0.8rem;
                    }
                }
            }
            .client-logo-container {
                max-width: 657px;
                margin: 20px auto;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    width: 168px;
                    padding: 23px 20px;
                }
            }

            .mr-5 {
                margin-right: 30px;
            }
            .clients-testimonial-container {
                max-width: 880px;
                margin: auto;
                display: flex;
                flex-direction: inline;
                .testimonial-card-1 {
                    padding: 0 10px;
                }
                .testimonial-card-2 {
                    padding: 0 10px;
                }
                .testimonial-card {
                    border-radius: 10px;
                    margin: 15px auto !important;
                    height: 270px;
                    position: relative;
                    max-width: 90%;
                    padding: 10px;
                    .quote {
                        position: absolute;
                        top: -26px;
                        left: 2px;
                        font-size: 65px;
                    }
                    .denise {
                        -webkit-transform: scaleX(-1);
                        transform: scaleX(-1);
                    }
                    .testimonial-card-text {
                        margin-top: 0;
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        height: 213px;
                        .testimonial-text {
                            padding: 5px 0;
                            margin-top: 0;
                            font-size: 0.9rem;
                            line-height: 20px;
                        }
                        .testimonial-details {
                            font-size: 1.4rem;
                            margin: 0;
                            display: flex;
                            align-items: center;
                            .details {
                                padding: 0;
                                margin-left: 5px;
                                .v-rating {
                                    margin-bottom: -10px;
                                    font-size: 10px;
                                }
                                span {
                                    margin-top: -10px;
                                    font-size: 0.6rem;
                                    line-height: 10px;
                                }
                            }

                            img {
                                height: 35px;
                                border-radius: 8px;
                            }
                        }
                    }
                }
                .denise-card {
                    .testimonial-card {
                        height: 240px;
                    }
                }
            }
        }
    }
}

@media (max-width: 417px) {
    .testimonial-card-1 {
        .testimonial-card {
            height: 320px !important;
        }
    }
    .testimonial-card-2 {
        .testimonial-card {
            height: 280px !important;
        }
    }
}
// //xl
// @media (min-width: 1904px) {
//     .client-section {
//         .client-banner {
//             .clients-text-container {
//                 max-width: 685px ;
//                 margin-left: 89px ;
//                 .clients-title {
//                     font-family: "GothamRounded" ;
//                     font-weight: light ;
//                     line-height: 85px ;
//                     padding: 60px 0 4px 0 ;
//                     font-size: 5rem ;
//                     max-width: 500px;
//                 }
//                 .clients-subtitle {
//                     font-size: 1.1rem ;
//                     letter-spacing: 0.15em ;
//                 }
//             }
//         }
//         .client-logo-container {
//             max-width: 1800px ;
//             img {
//                 width: 250px ;
//                 padding: 0 30px ;
//             }
//         }
//     }

//     .clients-testimonial-container {
//         padding: 10px 329px ;
//         .testimonial-card {
//             margin: auto ;
//             padding: 10px 50px ;
//             max-width: 7750px ;
//             .testimonial-text {
//                 font-size: 1rem ;
//                 line-height: 24px ;
//                 padding: 0 10px 30px 10px ;
//             }
//             .testimonial-details {
//                 font-size: 2.4rem ;
//                 margin: 0 10px ;
//                 display: flex;
//                 align-items: center ;
//                 .details {
//                     padding: 0 ;
//                     margin-left: 20px ;
//                     .v-rating {
//                         margin-bottom: -30px ;
//                     }
//                     span {
//                         margin-top: -10px ;
//                         font-size: 0.9rem ;
//                     }
//                 }
//             }
//         }

//         .testimonial-card-text {
//             margin-top: 0px ;
//         }
//         .testimonial-text {
//             padding: 0 33px 20px 33px ;
//         }
//     }
// }
</style>
